import React from "react";
import { Typography } from "@mui/material";
import { HasClassName } from "@lib/types";
import { makeStyles } from "@providers/Mui";
import clsx from "clsx";

type H7Props = HasClassName & {};

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: 13,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
}));

export const H7: React.FC<H7Props> = ({ children, className }) => {
  const classes = useStyles();
  return (
    <Typography className={clsx(classes.root, className)}>
      {children}
    </Typography>
  );
};
